import { Mail, Loader2, Send, AlertCircle } from "lucide-react";
import { Card } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";

export const DigestCard = ({ last, sending, onSend }) => {
  const lastWhen = last?.sent_at ? new Date(last.sent_at).toLocaleString("es-CO") : null;
  const lastOk = last?.ok;
  return (
    <Card className="bg-cm-ink text-cm-cream border-0 shadow-none p-6 mt-6" data-testid="digest-card">
      <div className="flex items-start gap-4 flex-wrap">
        <div className="h-10 w-10 rounded-md bg-cm-yellow/20 flex items-center justify-center flex-shrink-0">
          <Mail className="h-5 w-5 text-cm-yellow" />
        </div>
        <div className="flex-1 min-w-[240px]">
          <p className="text-[10px] uppercase tracking-widest text-cm-cream/60 font-medium">Informe semanal por correo</p>
          <h3 className="font-serif text-lg text-cm-yellow mt-1">Resumen automático cada lunes 7:00 AM</h3>
          <p className="text-xs text-cm-cream/70 mt-1 max-w-2xl">
            Cada lunes a las 7:00 (Bogotá) se envía a <span className="font-mono text-cm-cream">gerencia comercial</span> un resumen
            de la semana anterior: ventas totales, comparativo vs. semana previa, top vendedores, marcas y productos.
          </p>
          {lastWhen ? (
            <div className="text-[11px] text-cm-cream/60 mt-2 flex items-center flex-wrap gap-1" data-testid="digest-last">
              <span>Último envío: {lastWhen}</span>
              {lastOk
                ? <Badge variant="outline" className="ml-1 text-[10px] border-green-300/40 text-green-300 bg-green-900/20">enviado</Badge>
                : <Badge variant="outline" className="ml-1 text-[10px] border-red-300/40 text-red-300 bg-red-900/20">error {last?.status_code}</Badge>}
            </div>
          ) : (
            <div className="text-[11px] text-cm-cream/50 mt-2 flex items-center gap-1.5" data-testid="digest-no-history">
              <AlertCircle className="h-3 w-3" /> Aún no se ha enviado ningún resumen. Si Resend no está configurado, te avisará al intentar enviar.
            </div>
          )}
        </div>
        <Button
          onClick={onSend}
          disabled={sending}
          className="bg-cm-yellow text-cm-ink hover:bg-cm-yellow/90 border-0"
          data-testid="digest-send-now-btn"
        >
          {sending ? (
            <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Enviando...</>
          ) : (
            <><Send className="h-4 w-4 mr-2" /> Enviar prueba ahora</>
          )}
        </Button>
      </div>
    </Card>
  );
};
